// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-education-table {
  margin-bottom: 10px;
}

/* Education Question Section */
.education-question {
  margin-bottom: 15px;
}

.education-question h4 {
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.education-options {
  display: flex;
  gap: 20px;
  margin-top: 8px;
}

.radio-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  -webkit-user-select: none;
          user-select: none;
}

.radio-option input[type="radio"] {
  margin-right: 8px;
  cursor: pointer;
  width: 16px;
  height: 16px;
  accent-color: #667eea;
}

.radio-option:hover {
  color: #667eea;
}

/* Education Details Section */
.education-details {
  margin-top: 15px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  position: sticky;
  top: 0;
  z-index: 10;
}

.table-header h4 {
  margin: 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.add-row-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
  flex-shrink: 0;
  white-space: nowrap;
}

.add-row-btn:hover {
  background: #0056b3;
}

.empty-state {
  padding: 40px 20px;
  text-align: center;
  color: #6c757d;
}

.empty-state p {
  margin: 0 0 15px 0;
  font-size: 14px;
}

.add-first-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.add-first-btn:hover {
  background: #218838;
}

.table-container {
  overflow-x: auto;
}

.table-footer {
  padding: 15px 20px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  text-align: center;
}

.add-hint {
  margin: 0 0 10px 0;
  color: #6c757d;
  font-size: 14px;
  font-style: italic;
}

.add-another-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.add-another-btn:hover {
  background: #218838;
}

.education-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.education-table th {
  background: #f8f9fa;
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #dee2e6;
  white-space: nowrap;
}

.education-table td {
  padding: 8px;
  border-bottom: 1px solid #e9ecef;
  vertical-align: top;
}

.education-table input,
.education-table textarea,
.education-table select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.education-table input:focus,
.education-table textarea:focus,
.education-table select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.education-table input.invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25);
}

.education-table textarea {
  resize: vertical;
  min-height: 60px;
}

.education-table select {
  background: white;
}

.remove-btn {
  background: #dc3545;
  color: white;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.remove-btn:hover {
  background: #c82333;
}

.error-text {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.education-row:hover {
  background-color: #f8f9fa;
}

/* Responsive design */
@media (max-width: 768px) {
  .table-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
  
  .education-table {
    font-size: 12px;
  }
  
  .education-table th,
  .education-table td {
    padding: 6px 4px;
  }
  
  .education-table input,
  .education-table textarea,
  .education-table select {
    font-size: 12px;
    padding: 4px 6px;
  }
}

/* Column widths for better layout */
.education-table th:nth-child(1),
.education-table td:nth-child(1) {
  width: 12%;
  min-width: 100px;
}

.education-table th:nth-child(2),
.education-table td:nth-child(2) {
  width: 12%;
  min-width: 100px;
}

.education-table th:nth-child(3),
.education-table td:nth-child(3) {
  width: 15%;
  min-width: 120px;
}

.education-table th:nth-child(4),
.education-table td:nth-child(4) {
  width: 18%;
  min-width: 140px;
}

.education-table th:nth-child(5),
.education-table td:nth-child(5) {
  width: 15%;
  min-width: 120px;
}

.education-table th:nth-child(6),
.education-table td:nth-child(6) {
  width: 20%;
  min-width: 160px;
}

.education-table th:nth-child(7),
.education-table td:nth-child(7) {
  width: 12%;
  min-width: 100px;
}

.education-table th:nth-child(8),
.education-table td:nth-child(8) {
  width: 6%;
  min-width: 50px;
  text-align: center;
} `, "",{"version":3,"sources":["webpack://./src/components/DynamicEducationTable.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;;IAGE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,oCAAoC;AACpC;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".dynamic-education-table {\n  margin-bottom: 10px;\n}\n\n/* Education Question Section */\n.education-question {\n  margin-bottom: 15px;\n}\n\n.education-question h4 {\n  margin: 0 0 10px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.education-options {\n  display: flex;\n  gap: 20px;\n  margin-top: 8px;\n}\n\n.radio-option {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  user-select: none;\n}\n\n.radio-option input[type=\"radio\"] {\n  margin-right: 8px;\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n  accent-color: #667eea;\n}\n\n.radio-option:hover {\n  color: #667eea;\n}\n\n/* Education Details Section */\n.education-details {\n  margin-top: 15px;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.table-header h4 {\n  margin: 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.add-row-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.add-row-btn:hover {\n  background: #0056b3;\n}\n\n.empty-state {\n  padding: 40px 20px;\n  text-align: center;\n  color: #6c757d;\n}\n\n.empty-state p {\n  margin: 0 0 15px 0;\n  font-size: 14px;\n}\n\n.add-first-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.add-first-btn:hover {\n  background: #218838;\n}\n\n.table-container {\n  overflow-x: auto;\n}\n\n.table-footer {\n  padding: 15px 20px;\n  background: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n  text-align: center;\n}\n\n.add-hint {\n  margin: 0 0 10px 0;\n  color: #6c757d;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.add-another-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.add-another-btn:hover {\n  background: #218838;\n}\n\n.education-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.education-table th {\n  background: #f8f9fa;\n  padding: 12px 8px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 2px solid #dee2e6;\n  white-space: nowrap;\n}\n\n.education-table td {\n  padding: 8px;\n  border-bottom: 1px solid #e9ecef;\n  vertical-align: top;\n}\n\n.education-table input,\n.education-table textarea,\n.education-table select {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.education-table input:focus,\n.education-table textarea:focus,\n.education-table select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.education-table input.invalid {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25);\n}\n\n.education-table textarea {\n  resize: vertical;\n  min-height: 60px;\n}\n\n.education-table select {\n  background: white;\n}\n\n.remove-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.remove-btn:hover {\n  background: #c82333;\n}\n\n.error-text {\n  color: #dc3545;\n  font-size: 12px;\n  margin-top: 4px;\n  display: block;\n}\n\n.education-row:hover {\n  background-color: #f8f9fa;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .table-header {\n    flex-direction: column;\n    gap: 10px;\n    align-items: flex-start;\n  }\n  \n  .education-table {\n    font-size: 12px;\n  }\n  \n  .education-table th,\n  .education-table td {\n    padding: 6px 4px;\n  }\n  \n  .education-table input,\n  .education-table textarea,\n  .education-table select {\n    font-size: 12px;\n    padding: 4px 6px;\n  }\n}\n\n/* Column widths for better layout */\n.education-table th:nth-child(1),\n.education-table td:nth-child(1) {\n  width: 12%;\n  min-width: 100px;\n}\n\n.education-table th:nth-child(2),\n.education-table td:nth-child(2) {\n  width: 12%;\n  min-width: 100px;\n}\n\n.education-table th:nth-child(3),\n.education-table td:nth-child(3) {\n  width: 15%;\n  min-width: 120px;\n}\n\n.education-table th:nth-child(4),\n.education-table td:nth-child(4) {\n  width: 18%;\n  min-width: 140px;\n}\n\n.education-table th:nth-child(5),\n.education-table td:nth-child(5) {\n  width: 15%;\n  min-width: 120px;\n}\n\n.education-table th:nth-child(6),\n.education-table td:nth-child(6) {\n  width: 20%;\n  min-width: 160px;\n}\n\n.education-table th:nth-child(7),\n.education-table td:nth-child(7) {\n  width: 12%;\n  min-width: 100px;\n}\n\n.education-table th:nth-child(8),\n.education-table td:nth-child(8) {\n  width: 6%;\n  min-width: 50px;\n  text-align: center;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
